import { cn } from '@/lib/utils';
import { useT } from '@/str';
import { SCREEN } from '@/components/layout';

const BLOCK = 'animate-skeleton rounded-card bg-muted';

export function Skeleton({ shape, count }: { shape: 'rows' | 'grid'; count: number }) {
  const t = useT();
  return (
    <div role="status" aria-label={t.srLoading} aria-busy data-skeleton={shape} className={SCREEN}>
      <div className="flex flex-col gap-2">
        <span className={cn(BLOCK, 'rounded-ctl h-3 w-24')} />
        <span className={cn(BLOCK, 'rounded-ctl h-6 w-44')} />
      </div>
      {shape === 'rows' ? (
        <div className="flex flex-col gap-2">
          {Array.from({ length: count }, (_, i) => (
            <span key={i} className={cn(BLOCK, 'h-15')} />
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-3 gap-3">
          {Array.from({ length: count }, (_, i) => (
            <span key={i} className={cn(BLOCK, 'aspect-square')} />
          ))}
        </div>
      )}
    </div>
  );
}
